import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Use consistent icons
import styles from '../assets/css/Dropdown.module.css'; // Import CSS Module for Dropdown specific styles
import mineStyles from '../assets/css/Mine.module.css'; // Import Mine styles for base item look

const Dropdown = ({
    icon,        // Expecting a React Node (e.g., <FaWallet />)
    name,
    menu = [],   // Array of menu items { name: string, url: string, click?: function }
    url,         // Optional URL for the main item if it's NOT a dropdown trigger
    // Props to allow parent styling (like from Mine.module.css)
    triggerClassName = mineStyles.optionItem,
    iconClassName = mineStyles.optionIcon,
    nameClassName = mineStyles.optionName,
    arrowClassName = mineStyles.optionArrow
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasSubMenu = Array.isArray(menu) && menu.length > 0;

    const toggleMenu = (e) => {
        // Only toggle if there's a submenu
        if (hasSubMenu) {
            e.preventDefault(); // Prevent navigation if it's a dropdown trigger
            setIsOpen(!isOpen);
        }
        // If no submenu and no URL, it does nothing by default
        // If no submenu but has URL, the Link component handles navigation
    };

    // Determine the element type for the trigger
    // If it has a menu, it should act like a button (toggle)
    // If it has a URL but no menu, it's a simple Link
    // If it has neither, it's a non-interactive div (or could be disabled button)
    const TriggerElement = hasSubMenu ? 'button' : (url ? Link : 'div');
    const triggerProps = {
        className: `${triggerClassName} ${styles.dropdownTrigger}`, // Combine base style with dropdown specific
        onClick: hasSubMenu ? toggleMenu : undefined, // Only toggle if submenu exists
        ...(url && !hasSubMenu && { to: url }), // Add 'to' prop only if it's a simple Link
        ...(TriggerElement === 'button' && { type: 'button' }), // Add type for button
        'aria-haspopup': hasSubMenu ? 'true' : undefined,
        'aria-expanded': hasSubMenu ? isOpen : undefined,
    };


    return (
        <div className={styles.dropdownContainer}> {/* Main container for positioning */}
            <TriggerElement {...triggerProps}>
                {icon && <span className={iconClassName}>{icon}</span>}
                <span className={nameClassName}>{name}</span>
                {/* Show arrow only if it's a dropdown */}
                {hasSubMenu && (
                    <span className={`${arrowClassName} ${styles.dropdownArrow}`}>
                        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                )}
                 {/* Show arrow placeholder if it's just a link for alignment */}
                 {!hasSubMenu && url && (
                     <span className={`${arrowClassName} ${styles.dropdownArrowPlaceholder}`}>&gt;</span>
                 )}
            </TriggerElement>

            {/* Dropdown Menu */}
            {hasSubMenu && isOpen && (
                <ul className={styles.dropdownMenu}>
                    {menu.map((element, index) => (
                        <li key={index} className={styles.dropdownMenuItem}>
                           {/* Use Link for internal navigation */}
                           <Link
                               to={element.url}
                               onClick={element.click} // Optional click handler on menu item
                               className={styles.dropdownMenuLink}
                           >
                               {element.name}
                           </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Dropdown;
